import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router-dom';

import Profile from './Profile';
import { environment } from '../../environment';

class Login extends Component {
    render() {
        return (
            <a href={environment.authUrl}>
                <RaisedButton {...this.props} label="Login" />
            </a>
        );
    }
}

class Logo extends Component {
    render() {
        return (
            <Link to="/scheduler">
                <img src="/scheduler.png" alt="logo" height="52px" />
            </Link>
        );
    }
}

class Toolbar extends Component {
    render() {
        const { auth } = this.props;

        return (
            <div>
                <AppBar className="AppBar"
                    title={<Link to="/scheduler">Agendador de Tarefas</Link>}
                    iconElementLeft={<Logo />}
                    iconElementRight={auth ? <Profile {...this.props} /> : <Login />}
                    style={{position: 'fixed', top: 0}}
                />
            </div>
        );
    }
}

export default Toolbar;


// WEBPACK FOOTER //
// ./src/components/layout/Toolbar.js